<template>
  <div id="cart">
    <dd-header
      ref="menuRef"
      :headerType=2
      :isDcPriceDisp="!userInfo.isProfitFlag"
    />
    <div id="container">
      <div class="title title2"><h2>カート</h2></div>
      <div style="display: flex;">
        <div id="content">
          <div class="caution_field" v-if="isDisProduct===true">
            <div class="caution_inner">
              <div class="caution_title">
                <img class="caution_icon" :src="getImage('common/icon_caution_y.svg')" alt="">
                <p>重要なお知らせ</p>
              </div>
              <ul class="caution_text">
                <li>カート内に商品仕様が変更、または取り扱いが終了した商品が含まれている為、ご注文へ進めません。</li>
                <li>対象商品をカートから削除し、別の商品をご検討ください。</li>
              </ul>
            </div>
          </div>
          <div v-for="(cart,index) in nowList" :key="'cart-' + index">
            <dd-cartitem
              :cartData="cart"
              :type="'cart'"
              :isOutputCG="isHasegawaCp"
              :profitProb="cartData.profitProb"
              @afterCart="afterCart"
              @deleteCartItem="deleteCartItem"
              @updateProductCnt="updateProductCnt"
              @showCameraModal="showCameraModal"
              @onShowEstimateModal="onShowEstimateModal"
            />
          </div>
          <template v-if="afterList.length > 0">
            <h2 class="title2">後で買うリスト（{{afterList.length}}点）</h2>
            <div v-for="(cart,index) in afterList" :key="'aftercart-' + index">
              <dd-cartitem
                :cartData="cart"
                :type="'after'"
                :profitProb="cartData.profitProb"
                @reverseCart="reverseCart"
                @deleteCartItem="deleteCartItem"
                @updateProductCnt="updateProductCnt"
              />
            </div>
          </template>
        </div>
        <div class="side">
          <div class="cart_price">
            <template v-if="isDispPrice">
              <div class="price_list" v-if="isDispPrice">
                <ul>
                  <li>
                    <div>商品・配送 計</div>
                    <div>{{formatPrice(profitPrice(cartData.orderPrice.itemSubTotalPrice))}}</div>
                  </li>
                  <li>
                    <div>消費税(10%)</div>
                    <div>{{formatPrice(profitPrice(cartData.orderPrice.itemSubTotalTax))}}</div>
                  </li>
                  <li class="n_separator">
                    <div>税込金額(A)</div>
                    <div>{{formatPrice(profitPrice(cartData.orderPrice.itemTotalPrice))}}</div>
                  </li>
                </ul>
              </div>
              <div class="price_list" v-if="isConstruct">
                <ul>
                  <li>
                    <div>組立設置他サービス 計</div>
                    <div>{{formatPrice(profitPrice(cartData.orderPrice.optSubTotalPrice))}}</div>
                  </li>
                  <li v-if="cartData.orderPrice.discntPrice">
                    <div>諸経費割引</div>
                    <div>{{formatPrice(profitPrice(-cartData.orderPrice.discntPrice))}}</div>
                  </li>
                  <li class="n_separator" v-if="cartData.orderPrice.discntPrice">
                    <div>小計</div>
                    <div>{{formatPrice(profitPrice(cartData.orderPrice.discntSubTotalPrice))}}</div>
                  </li>
                  <li>
                    <div>消費税(10%)</div>
                    <div>{{formatPrice(profitPrice(cartData.orderPrice.optTotalTax))}}</div>
                  </li>
                  <li class="n_separator">
                    <div>税込金額(B)</div>
                    <div>{{formatPrice(profitPrice(cartData.orderPrice.optTotalPrice))}}</div>
                  </li>
                </ul>
              </div>
              <div class="total_price">
                <ul>
                  <li v-if="isConstruct">(A) + (B)</li>
                  <li v-else>(A)</li>
                  <li>
                    <div>ご請求額合計</div>
                    <div>{{formatPrice(profitPrice(cartData.orderPrice.totalPrice))}}</div>
                  </li>
                </ul>
              </div>
            </template>
            <template v-else>
              <div class="price_list total_price">
                <ul>
                  <li>
                    <div>ご請求額合計</div>
                    <div>￥-----------</div>
                  </li>
                </ul>
              </div>
            </template>
            <div class="btn_field">
              <ul>
                <li>
                  <span class="cart_btn_field">
                    <button class="main_btn order_btn" :disabled="isDifferPostCd || isDifferConstructPostCd || isCarryAll || isDisProduct || !isOneMaker" @click="estimate()">見積り</button>
                  </span>
                </li>
                <li>
                  <span class="cart_btn_field">
                    <button class="main_btn order_btn" :disabled="isDifferPostCd || isDifferConstructPostCd || isCarryAll || isDisProduct || !isOneMaker" @click="order()">注文へ進む</button>
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <div class="cart_caition">
            <div class="caution_text_field">
              <div class="caution_title">※一度のご注文で1納品先、また1メーカーの商品をご注文いただけます。</div>
              <div class="caution_text">納品先・組立設置先が異なる商品や、複数メーカーの商品をご注文する場合は「後で買うリスト」機能を活用し、1納品先、また1メーカーの商品になるようカート内を整理いただいた上でご注文ください。</div>
            </div>
            <div class="caution_text_field" v-if="isHasegawaCp">
              <div class="caution_title">※受け取り搬入サービスをご利用のお客様へ</div>
              <div class="caution_text">サービスをご利用する商品とご利用しない商品を一度に購入する事はできません。</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import axios from 'axios'
import {mapActions, mapState} from 'vuex'
import * as AppEc from '../utils/AppEc'
import * as Api from '../../utils/Api'
import * as App from '../../utils/App'
import {DC_URL, DC_STORAGE_KEY, STRUCT_CORP_ID_ST, STRUCT_CORP_ID_ED} from '../../constants/App'
import {PAYMENT_STATUS} from '../../constants/Type'
import * as FormUtil from '../../utils/FormUtil'
import LoadingModal from '../../components/common/LoadingModal'
import DcCameraPositionModal from '../components/output/DcCameraPositionModal'

// Module
import Header from '../components/common/DcHeader'
import CartItem from '../components/common/CartItem'

const CART_PRODUCT_MAX_COUNT = 30

export default {
  name: 'Cart',
  components: {
    'dd-header': Header,
    'dd-cartitem': CartItem,
    'dd-camera-position-modal': DcCameraPositionModal,
    'dd-loading-modal': LoadingModal
  },
  data () {
    return {
      isHasegawaCp: false,
      errorMessage: {},
      validateErrorMessages: {},
      delFlag: false,
      afterFlag: false,
      reverseFlag: false,
      updateFlag: false,
      userInfo: {}
    }
  },
  computed: {
    // ユーザー一覧
    ...mapState({
      cartData: state => state.cartData
    }),
    nowList: function () {
      if (!this.cartData || Object.keys(this.cartData).length <= 0) return {}
      return this.cartData.cartList.filter(c => c.status === PAYMENT_STATUS.SAVE_CART.code)
    },
    afterList: function () {
      if (!this.cartData || Object.keys(this.cartData).length <= 0) return {}
      return this.cartData.cartList.filter(c => c.status === PAYMENT_STATUS.AFTER_CART.code)
    },
    constructList: function () {
      if (!this.cartData || Object.keys(this.cartData).length <= 0) return {}
      return this.cartData.cartList.filter(c => c.status === PAYMENT_STATUS.SAVE_CART.code)
        .filter(c => c.opExFlag === true)
    },
    constructData: function () {
      if (!this.cartData || Object.keys(this.cartData).length <= 0) return {}
      return this.cartData.cartList.filter(c => c.status === PAYMENT_STATUS.SAVE_CART.code)
        .find(c => c.opExFlag === true)
    },
    isCarryIn: function () {
      if (!this.cartData || Object.keys(this.cartData).length <= 0) return false
      let carryCnt = this.cartData.cartList.filter(c => c.status === PAYMENT_STATUS.SAVE_CART.code)
        .filter(c => c.opCarryFlag === true)
        .length
      return (carryCnt > 0)
    },
    isConstruct: function () {
      if (!this.cartData || Object.keys(this.cartData).length <= 0) return false
      return this.cartData.cartList.filter(c => c.status === PAYMENT_STATUS.SAVE_CART.code)
        .some(c => c.opExFlag === true)
    },
    isCarryAll: function () {
      if (!this.cartData || Object.keys(this.cartData).length <= 0) return true
      let carryCnt = this.cartData.cartList.filter(c => c.status === PAYMENT_STATUS.SAVE_CART.code)
        .filter(c => c.opCarryFlag === true)
        .length
      let dataCnt = this.cartData.cartList.filter(c => c.status === PAYMENT_STATUS.SAVE_CART.code)
        .length
      return (carryCnt !== 0 && carryCnt !== dataCnt)
    },
    isOneMaker: function () {
      if (!this.cartData || Object.keys(this.cartData).length <= 0) return false
      let nowList = this.cartData.cartList.filter(c => c.status === PAYMENT_STATUS.SAVE_CART.code)
      if (nowList.every(v => v.infoFileCorpId === nowList[0].infoFileCorpId)) {
        return true
      }
      return false
    },
    isDifferPostCd: function () {
      if (!this.nowList || Object.keys(this.nowList).length <= 0) return true
      let postcd = this.nowList[0].infoDeliPostcd
      let unmatchCnt = this.nowList.filter(c => c.infoDeliPostcd !== postcd).length
      return (unmatchCnt > 0)
    },
    isDifferConstructPostCd: function () {
      if (!this.constructList || Object.keys(this.constructList).length <= 0) return false
      let postcd = this.constructList[0].infoStructPostcd
      let unmatchCnt = this.constructList.filter(c => c.infoStructPostcd !== postcd).length
      return (unmatchCnt > 0)
    },
    isWorkFlag: function () {
      let structCnt = this.nowList.filter(d => d.opExFlag === true).length
      return structCnt > 0
    },
    pageList: function () {
      let pageList = []
      if (!this.isCarryIn) {
        pageList.push({id: 'order', key: 'orderInput', title: '納品先入力'})
      }
      if (this.isWorkFlag) {
        pageList.push({id: 'struct', key: 'struct', title: '組立設置情報入力'})
      }
      pageList.push({id: 'confirm', key: 'orderConfirm', title: 'ご注文内容確認'})
      if (!this.userInfo.isAccountPay) {
        pageList.push({id: 'payment', key: 'payment', title: 'お支払い方法選択'})
      }
      pageList.push({id: 'complete', key: 'orderComp', title: '注文完了'})
      return pageList
    },
    isDisProduct: function () {
      if (!this.cartData || Object.keys(this.cartData).length <= 0) return false
      return this.cartData.cartList
        .map(c => c.isDisProduct)
        .includes(true)
    },
    isDispPrice: function () {
      if (this.isDifferPostCd || this.isDifferConstructPostCd || this.isCarryAll) {
        return false
      }
      return true
    }
  },
  methods: {
    ...mapActions({ getCartData: 'loadCartData' }),
    // getCart: function () {
    //   axios.get(DC_URL.CART + '/getinfo')
    //     .then(response => {
    //       if (response.data.errorMessage) {
    //         this.handleErrorMessage(response)
    //       } else {
    //         this.cartList = response.data.data
    //       }
    //     }).catch(error => {
    //       Api.handleError(error)
    //     }).finally(() => {
    //       this.$refs.loadingModalRef.showModal(false)
    //     })
    // },
    order: function () {
      if (this.isDifferPostCd) return
      if (this.isDifferConstructPostCd) return
      if (this.isCarryAll) return
      if (!this.nowList || Object.keys(this.nowList).length <= 0) return
      axios.get(DC_URL.CART + '/order')
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            this.orderNext()
          }
        }).catch(error => {
          Api.handleError(error)
        }).finally(() => {
          this.$refs.loadingModalRef.showModal(false)
        })
    },
    orderNext: function () {
      App.removeLocalStorage(DC_STORAGE_KEY.ORDER_DATA)
      App.removeLocalStorage(DC_STORAGE_KEY.DELIVERY_DATA)
      App.removeLocalStorage(DC_STORAGE_KEY.STRUCT_DATA)
      let commonData = this.nowList[0]
      let orderData = {
        categoryId: commonData.infoCategoryType,
        infoW: commonData.infoW,
        infoH: commonData.infoH,
        infoD: commonData.infoD,
        infoFillerLeft: commonData.infoFillerLeft,
        infoFillerRight: commonData.isRightFiller,
        infoFillerCenter: commonData.infoFillerCenter,
        colorDoor: commonData.doorColor,
        colorCabine: commonData.boxColor,
        colorCounter: commonData.centerColor,
        spaceJoincd: commonData.infoSpaceJoincd,
        dcProductCount: commonData.infoProductCount,
        workFlag: this.isWorkFlag,
        pageList: this.pageList,
        isCarryIn: this.isCarryIn,
        corpId: commonData.infoFileCorpId
      }
      App.setLocalStorage(DC_STORAGE_KEY.ORDER_DATA, orderData)
      let deliveryData = {
        businessId: commonData.infoBusinessId,
        businessName: commonData.infoName,
        building: commonData.infoDeliBuilding,
        postcd: commonData.infoDeliPostcd,
        state: commonData.infoDeliState,
        city: commonData.infoDeliCity,
        street: commonData.infoDeliStreet,
        userLastName: commonData.infoDeliLastName,
        userFirstName: commonData.infoDeliFirstName,
        userLastNameKana: commonData.infoDeliLastNameKana,
        userFirstNameKana: commonData.infoDeliFirstNameKana,
        tel: commonData.infoDeliTel,
        deliveryDate: this.cartData.deliveryDate,
        message: undefined,
        selectTime: 0,
        isRegistAddress: false
      }
      App.setLocalStorage(DC_STORAGE_KEY.DELIVERY_DATA, deliveryData)
      let ldata = this.constructData
      if (ldata && Object.keys(ldata).length > 0) {
        let constructForm = {
          businessName: commonData.infoName,
          postcd: ldata.infoStructPostcd,
          state: ldata.infoStructState,
          city: ldata.infoStructCity,
          street: ldata.infoStructStreet,
          userLastName: ldata.infoStructLastName,
          userFirstName: ldata.infoStructFirstName,
          userLastNameKana: ldata.infoStructLastNameKana,
          userFirstNameKana: ldata.infoStructFirstNameKana,
          tel: ldata.infoStructTel,
          desiredDate1st: '',
          desiredDate2nd: '',
          desiredDate3rd: '',
          homeType: 1,
          parkingSpace: false,
          message: '',
          isNewInput: false
        }
        App.setLocalStorage(DC_STORAGE_KEY.STRUCT_DATA, constructForm)
      }
      if (this.isCarryIn) {
        this.$router.push({
          name: 'ConstructInput'
        })
      } else {
        this.$router.push({
          name: 'OrderInput'
        })
      }
    },
    estimate: function () {
      this.$refs.loadingModalRef.showModal(true)
      axios({
        method: 'GET',
        url: DC_URL.CART + '/estimate',
        responseType: 'blob'
      }).then(response => {
        if (response.data.errorMessage) {
          this.handleErrorMessage(response)
          this.$refs.loadingModalRef.showModal(false)
        } else {
          var pdf = response.data
          let blob = new Blob([pdf], {type: 'application/xlsx;charset=SJIS'})
          if (window.navigator.msSaveBlob) {
            window.navigator.msSaveBlob(blob, '見積書.xlsx')
          } else {
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = '見積書.xlsx'
            link.click()
          }
          this.$refs.loadingModalRef.showModal(false)
        }
      }).catch(error => {
        Api.handleError(error)
        this.$refs.loadingModalRef.showModal(false)
      })
    },
    afterCart: function (odMgCode) {
      if (this.afterFlag) return
      if (this.afterList.length >= CART_PRODUCT_MAX_COUNT) {
        App.showModal({
          messages: ['後で買うリストに追加できる商品は' + CART_PRODUCT_MAX_COUNT + '個までになります。']
        })
        return
      }
      this.afterFlag = true
      this.$refs.loadingModalRef.showModal(true)
      let payload = {
        params: {
          odMgCode: odMgCode
        }
      }
      axios.get(DC_URL.CART + '/after', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
            this.$refs.loadingModalRef.showModal(false)
            this.afterFlag = false
          } else {
            this.$store.dispatch('loadCartData')
              .then(() => {
                this.$refs.loadingModalRef.showModal(false)
                this.afterFlag = false
              })
          }
        }).catch(error => {
          Api.handleError(error)
          this.$refs.loadingModalRef.showModal(false)
          this.afterFlag = false
        }).finally(() => {
        })
    },
    reverseCart: function (odMgCode) {
      if (this.reverseFlag) return
      if (this.nowList.length >= CART_PRODUCT_MAX_COUNT) {
        App.showModal({
          messages: ['カートに追加できる商品は' + CART_PRODUCT_MAX_COUNT + '個までになります。']
        })
        return
      }
      this.reverseFlag = true
      this.$refs.loadingModalRef.showModal(true)
      let payload = {
        params: {
          odMgCode: odMgCode
        }
      }
      axios.get(DC_URL.CART + '/reverse', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
            this.$refs.loadingModalRef.showModal(false)
            this.reverseFlag = false
          } else {
            this.$store.dispatch('loadCartData')
              .then(() => {
                this.$refs.loadingModalRef.showModal(false)
                this.reverseFlag = false
              })
          }
        }).catch(error => {
          Api.handleError(error)
          this.$refs.loadingModalRef.showModal(false)
          this.reverseFlag = false
        }).finally(() => {
        })
    },
    deleteCartItem: function (odMgCode) {
      if (this.delFlag) return
      this.delFlag = true
      this.$refs.loadingModalRef.showModal(true)
      let payload = {
        params: {
          odMgCode: odMgCode
        }
      }
      axios.get(DC_URL.CART + '/delete', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
            this.$refs.loadingModalRef.showModal(false)
            this.delFlag = false
          } else {
            this.$store.dispatch('loadCartData')
              .then(() => {
                this.$refs.loadingModalRef.showModal(false)
                this.delFlag = false
              })
          }
        }).catch(error => {
          Api.handleError(error)
          this.$refs.loadingModalRef.showModal(false)
          this.delFlag = false
        }).finally(() => {
        })
    },
    updateProductCnt: function (odMgCode, productCount) {
      if (this.updateFlag) return
      this.updateFlag = true
      this.$refs.loadingModalRef.showModal(true)
      let payload = {
        params: {
          odMgCode: odMgCode,
          productCount: productCount
        }
      }
      axios.get(DC_URL.CART + '/update', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            this.$store.dispatch('loadCartData')
          }
        }).catch(error => {
          Api.handleError(error)
        }).finally(() => {
          this.updateFlag = false
          this.$refs.loadingModalRef.showModal(false)
        })
    },
    showCameraModal: function (itemData) {
      let modalData = {
        onOk: (callback) => {
          this.$refs.loadingModalRef.showModal(true)
          let payload = {
            params: {
              id: itemData.id,
              cameraPosition: callback.cameraPosition
            }
          }
          axios.get(DC_URL.CART + '/cg', payload)
            .then(response => {
              if (response.data.errorMessage) {
                this.handleErrorMessage(response)
                this.$refs.loadingModalRef.showModal(false)
              } else {
                App.showModal({
                  messages: ['※出力物はメールで送られます。']
                })
                this.$refs.loadingModalRef.showModal(false)
              }
            }).catch(error => {
              let retError = Api.handleError(error, this.errorMessage, this.fieldErrorMessages)
              App.showModal({
                title: 'システムエラー',
                messages: [retError.errorMessage],
                messageType: 'error',
                textAlign: 'left'
              })
              this.$refs.loadingModalRef.showModal(false)
            })
        }
      }
      AppEc.showCameraPosModal(modalData)
    },
    handleErrorMessage: function (response) {
      if (!response || !response.data) {
        return
      }
      let modalData = {
        title: 'エラー',
        messages: response.data.errorMessage.split(/\r?\n/g),
        messageType: 'error',
        textAlign: 'left'
      }
      App.showModal(modalData)
    },
    onShowEstimateModal: function (estimateData) {
      this.$refs.loadingModalRef.showModal(true)
      // ダイアログ表示
      let modalData = {
        onOk: () => {
        },
        showSuccess: () => {
          this.$refs.loadingModalRef.showModal(false)
        },
        fileName: estimateData.fileName,
        titleDoor: estimateData.titleDoor,
        colorDoor: estimateData.colorDoor,
        titleCabine: estimateData.titleCabine,
        colorCabine: estimateData.colorCabine,
        titleCounter: estimateData.titleCounter,
        colorCounter: estimateData.colorCounter,
        priceData: estimateData.priceData,
        spaceJoincd: estimateData.spaceJoincd,
        dispOrderButton: false,
        dcProductCount: estimateData.dcProductCount,
        isCalcDelivery: true,
        isDrawing: estimateData.isDrawing,
        corpData: estimateData.corpData,
        isProfitFlag: true,
        isProductData: true
      }
      AppEc.showEstimateModal(modalData)
    },
    formatPrice: function (price) {
      return FormUtil.formatPrice(price)
    },
    profitPrice: function (price) {
      if (!price || !this.cartData || !this.cartData.orderPrice) return
      return (Math.ceil(price / this.cartData.orderPrice.profitProb))
    },
    getImage: function (image) {
      return App.getMmstyleResource(image)
    }
  }, // method end
  watch: {
  },
  mounted: function () {
    this.$store.dispatch('loadCartData', {reload: true})
  },
  created: function () {
    this.userInfo = App.getLocalStorage(DC_STORAGE_KEY.USER_INFO)
    this.isHasegawaCp = (this.userInfo && this.userInfo.corpId >= STRUCT_CORP_ID_ST && this.userInfo.corpId <= STRUCT_CORP_ID_ED)
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/dctop2.scss" lang="scss" scoped></style>
<style src="../css/input-list.scss" lang="scss" scoped></style>
<style src="../css/print.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
.cart_caition {
  top: 120px;
  min-width: 330px;
}
.cart_btn_field {
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/Cart.vue